import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/base/FaqAccordion";
import Hero from "@/pages/home/components/Hero";
import FocusSection from "@/pages/home/components/FocusSection";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import TrendingSection from "@/pages/home/components/TrendingSection";
import MethodSteps from "@/pages/home/components/MethodSteps";
import BrandSection from "@/pages/home/components/BrandSection";
import { faqList } from "@/mocks/faq";
import { usePageMeta } from "@/hooks/usePageMeta";

const homeFaq = faqList.slice(0, 4);

export default function Home() {
  usePageMeta({
    title: "蝌蚪爆料 - 实锤追踪与石锤证据对比 | 可信度核查",
    description:
      "蝌蚪爆料专注网络争议信息的实锤追踪与石锤证据对比，提供截图对比、时间线与依据分级，标注每起事件的可信度与真假辨析过程。",
    keywords: "蝌蚪爆料,蝌蚪爆料实锤,蝌蚪爆料石锤,蝌蚪爆料证据,蝌蚪爆料截图对比,蝌蚪爆料真假,蝌蚪爆料可信度",
    canonicalPath: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "蝌蚪爆料",
        url: "https://jiumeijiaju.cn/",
        description: "围绕网络争议信息的证据追踪与真假辨析内容站",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://jiumeijiaju.cn/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "蝌蚪爆料",
        url: "https://jiumeijiaju.cn/",
        email: "contact@kodo-expose.example.com",
        description: "以证据链、时间线与可信度标注为核心的争议信息核查内容站",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaq.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <Hero />
      <FocusSection />
      <CategoryGrid />
      <TrendingSection />
      <MethodSteps />

      <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="读者最常问的几件事"
              description="关于评分口径、依据分级与更正流程，这里集中说明。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1 whitespace-nowrap font-label text-sm text-primary-700 hover:text-primary-600 cursor-pointer"
            >
              查看全部问题 <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={homeFaq} defaultOpen={0} />
          </div>
        </div>
      </section>

      <BrandSection />
    </SiteLayout>
  );
}